import { gql } from '@apollo/client/core'

export const LOGIN_MUTATION = gql`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      token
      employee {
        id
        name
        email
        permission
        photoUrl
        roles {
          id
          name
        }
      }
    }
  }
`

export const ME_QUERY = gql`
  query Me {
    me {
      id
      name
      email
      permission
      photoUrl
      roles {
        id
        name
      }
    }
  }
`